import { render } from "./StudentLayout.vue?vue&type=template&id=34a675fe&scoped=true"
import script from "./StudentLayout.vue?vue&type=script&lang=js"
export * from "./StudentLayout.vue?vue&type=script&lang=js"

import "./StudentLayout.vue?vue&type=style&index=0&id=34a675fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34a675fe"]])

export default __exports__